import React, { Component, useState, useContext, useEffect } from "react";

import Colorer from 'color';
import styled from "styled-components";
import { ProductContext, ProductConsumer } from "../context";


const defTheme =  {
  id: 'magenta',
  name: 'Magenta Dark',
  colorText: '#D6E0E7',
  colorAccent: '#FF005B',
  colorAccentText: '#F6FAFF',
  colorBg: '#011627',

  borderRadius: 8,
  backgroundUrl: 'https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg',

  cardWidth: 240,
  cardPadding: 24,

  boxShadow: '0 5px 12px 0px rgba(0,0,0,0.2)',
  transitionTime: '0.3s',
  transitionEasing: 'ease-in-out',
  transition: 'all 0.3s ease-in-out',
  transitionStyle: '0.3s ease-in-out',
  fontFamily: '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
};



export function ColorRandomizerButton({
  saveTheme = 'saveTheme',
  colorsPanel,
  height = 36,
  targetBlock,
  targetElement,
  theme = {...defTheme},
  handleChange = ()=>{void(0)},
}) {

  let timeout;

  const [state, setState] = useState({
      colorsPanel: colorsPanel || false,
      roundness: 3,
      slider: 3,
      rotating: false, //needed for animation of the trigger
      scaling: 1,
      theme: theme,
  })


  const setColorRotate = (newAngle, saveOrNot) => {

    if (timeout) clearTimeout(timeout);

    // if (!state.rotating) {
      setState({
        ...state,
        rotating: Number(state.rotating) + 180,
        scaling: 0.5,
      })
    timeout = setTimeout(() => {

      handleChange(state.rotating)

      // vFC.setGlobalColors('rotate', newAngle, saveOrNot, targetBlock, targetElement);

      setState({
        ...state,
        colorAngle: newAngle,
        rotating: state.rotating + 180,
          scaling: 1,
      })}, 100)
    // }
  }

  // const vFC = useContext(ProductContext);

  // useEffect(() => {
  //   if (!state.theme || state.theme !== vFC.state.theme) {setState({
  //     ...state,
  //     theme: vFC.state.theme
  //   })}
  //   return () => {
  //     clearTimeout(timeout);
  //   };
  // }, [vFC])



  let mouse;

  const handleColorHover = stat => {
        // if (stat) {
        //   setAddFalse(true);
        // } else {
        //   setAddFalse(false);
        // }
      }

      return (

            <CssColoredShadow
              color={theme['colorAccent']}
              className="x_sectionhover"
              style={{
                  height: `${height}px`,
                  minHeight: `${height}px`,
                }}
            >
              <CssTopShadow/>
            <div className="x_randomize_0"
              style={{
                height: `${height}px`,
                minHeight: `${height}px`,
              }}
            >
              <div
                className="x_randomize"
                style={{
                  transform: `rotateZ(${state.rotating + 90}deg) scale(${state.scaling})`,
                  borderRadius: 500,
                }}
                onMouseMove={(e) => {
                  mouse = e.nativeEvent.clientX;
                  setState({
                    ...state,
                    rotating:  state.rotating + 20,
                    color: Colorer('red').rgb().rotate(state.rotating + 20).negate().hex(),
                  })
                }
                }
                onMouseDown={(e) => {
                  setColorRotate(29, saveTheme)
                }}

              >
                <div
                  className="xicon_white"
                  style={{
                    color: theme.colorAccentText,
                    backgroundColor: theme.colorAccent,
                  }}
                >
                refresh
                </div>
            </div>

              </div>
            </CssColoredShadow>


      )
}

const CssTopShadow = styled.div`
    box-shadow: inset 0 -2px 5px -1px ${({color}) => color
      ? `${color}`
      : `rgba(0, 0, 0, .51)`
    };
    pointer-events: none;
    z-index: 5;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
`
const CssColoredShadow = styled.div`
    width: 100%;
    background-color: ${({color}) => color
      ? `${color}`
      : `white`
    };
    box-shadow: ${({color}) => color
      ? `0 5px 17px -6px ${color}`
      : `0 5px 17px -6px rgba(0, 0, 0, .51)`
    };

    &:hover {
      box-shadow: ${({color}) => color
        ? `0 8px 20px -6px ${color};`
        : `0 8px 20px -6px #000;`
      }
    }
`